const BROWSER_INITIAL_STATE = {
  isWebPSupported: false,
};

export default BROWSER_INITIAL_STATE;
